import axios from "@/utils/api-v1"
// import store from '@/store/store.js'

export default {
  login(email, pwd) {
    return axios.post("/api/users", {
      email,
      password: pwd,
    })
  },
  // { email, referrer, firstName, lastName, zip, categories, utmParams,
  //   profileType, companyName } -- companyName for /hire signups (GFB-1413).
  registerUser(details) {
    return axios.post("/api/users/register", details)
  },
  getUser(userId) {
    return axios.get(`/api/users/${userId}`)
  },
  requestPasswordReset(email) {
    return axios.post("/api/users/requestPasswordReset", {
      email,
    })
  },
  // Either { emailConfirmationKey, password } (the emailed link) or
  // { email, code, password } (the 6-digit code, GFB-1412).
  confirmUserEmail(details) {
    return axios.post("/api/users/confirmEmail", details)
  },
  changeUserPassword(passwordResetKey, password) {
    return axios.post("/api/users/changeUserPassword", {
      passwordResetKey,
      password,
    })
  },
  changeAuthUserPassword(password) {
    return axios.post("/api/users/changeAuthUserPassword", {
      password,
    })
  },
  checkUserPassword(password) {
    return axios.post("/api/users/checkUserPassword", {
      password,
    })
  },
  deleteUser(id) {
    return axios.delete(`/api/users/${id}`)
  },
  async sendSupport(email, data) {
    return await axios.post(`/api/users/support/`, {
      email,
      data,
    })
  },
}
